/* eslint-disable node/no-unsupported-features/es-syntax */
import { INVENTORY_ROUTE_NAMES } from "@/shared";
export const INVENTORY_ROUTES = [
    {
        name: INVENTORY_ROUTE_NAMES.LIST,
        path: "/inventory",
        meta: {
            title: "menu.inventory_section",
        },
        component: () => import("../ui/InventoryList.vue"),
        props: (route) => ({
            ...route.params,
            ...route.query,
        }),
    },
    {
        name: INVENTORY_ROUTE_NAMES.CARD,
        path: "/inventory/:id",
        meta: {
            title: "words.inventory_card",
        },
        component: () => import("../ui/InventoryCard.vue"),
        props: true,
    },
    {
        name: INVENTORY_ROUTE_NAMES.ADD,
        path: "/inventory/add",
        meta: {
            title: "words.add_inventory_header",
        },
        component: () => import("../ui/InventoryEdit.vue"),
        props: true,
    },
    {
        name: INVENTORY_ROUTE_NAMES.EDIT,
        path: "/inventory/edit/:id",
        meta: {
            title: "words.edit_inventory",
        },
        component: () => import("../ui/InventoryEdit.vue"),
        props: true,
    },
    {
        name: INVENTORY_ROUTE_NAMES.COPY,
        path: "/inventory/copy/:id",
        meta: {
            title: "words.copy_inventory",
        },
        component: () => import("../ui/InventoryEdit.vue"),
        props: true,
    },
];
